import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  container2: {
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  container3: {
    width: "3%",
    height: "100%",
    backgroundColor: "#141417",
  },
  innerContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    width: "60%",
  },
  flexBoxSpaceBetween: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  inputContainer: {
    width: "47%",
  },
  btn: {
    width: "250px",
  },
  gapContainer: {
    display: "flex",
    alignItems: "center",
    gap: "32px",
  },
  gapContainer2: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  blackText: {
    fontWeight: "500",
    color: "#000000",
  },
  footer: {
    position: "absolute",
    bottom: "35px",
    color: "#666666 !important",
    fontSize: "16px !important",
  },
});

export default useStyles;
